import ReportsApi from '../../apis/Reports';

export default {
    namespaced: true,
    state: {
        movements: [],
        file_name: null
    },
    mutations: {
        set_movements (state, data) {
            state.movements = data;
        },
        set_file_name (state, value) {
            state.file_name = value;
        }
    },
    actions: {
        setMovements ({ commit }, data) {
            commit('set_movements', data);
        },
        async getKardexMovements({commit, dispatch}, filters) {
            commit('set_movements', []);
            return await ReportsApi.getKardexMovements(filters)
                .then( response => {
                    commit('set_movements', response.data);
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al listar consumos internos, vuelva a intentarlo.'
                    }, {root: true});
                })
        },

        async downloadConsumption({commit, dispatch}, filters) {
            commit('set_file_name', null);
            return await ReportsApi.downloadConsumption(filters)
                .then( response => {
                    commit('set_file_name', response.data.file_name);
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al descargar reporte de consumo interno, vuelva a intentarlo.'
                    }, {root: true});
                })
        },
        async downloadDecrease({commit, dispatch}, filters) {
            commit('set_file_name', null);
            return await ReportsApi.downloadDecrease(filters)
                .then( response => {
                    commit('set_file_name', response.data.file_name);
                })
                .catch( error => {
                    if (error.response?.status === 401) return null
                    dispatch('notifications/store_notification', {
                        type: 'error',
                        message: 'Ocurrió un error al descargar reporte de merma, vuelva a intentarlo.'
                    }, {root: true});
                })
        },
    }
}